import { useRef, useCallback } from 'react';

/**
 * Gestisce il cambiamento della stringa di search.
 *
 * Al primo SPACE apre solo il popup. Dopo cambia il search value e apre il popup
 *
 * @param onSearchValueChange callback di modifica
 * @param setShowPopup funzione per cambiare lo stato del popup
 * @returns funzione che modifica il cambiamento del valore di una input
 */
function useSearchValueChange(onSearchValueChange, setShowPopup) {
    const lastChangeOnlyOpenedPopupRef = useRef(false);
    const handleInputChange = useCallback((value, event) => {
        if (!lastChangeOnlyOpenedPopupRef.current && value === ' ') {
            // siamo alla prima pressione di SPACE, salto la modifica
            lastChangeOnlyOpenedPopupRef.current = true;
        }
        else {
            lastChangeOnlyOpenedPopupRef.current = false;
            onSearchValueChange(value, event);
        }
        setShowPopup(true);
    }, [onSearchValueChange, setShowPopup]);
    return handleInputChange;
}

export { useSearchValueChange as default };
